import axios from 'axios';
import constants from '../constants';
import { CustomerMetadata, ChildPracticeMetadata, Customer, CustomerAddress, CustomerService, TeamMember, User } from '../types';

const getCustomer = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer`)
  const customer: Customer | null = response.data
  
  return customer
};

const getCustomerService = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer-service`)
  const services: CustomerService[] = response.data
  
  return services
}

const getCustomerAddress = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer-address`)
  const address: CustomerAddress | null = response.data
  
  return address
}

const getTeamMembers = async (customerNumber: string): Promise<TeamMember[]> => {
  try {
    const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/users-practices?scope=withGroups`);
    return response.data ?? [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

const getGroups = async (customerNumber: string) => {
  try {
    const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/groups?scope=withMembers`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

const getBioBoxes = async (customerNumber: string, currentUser: User | null) => {
  try {
    let query = ''
    if (currentUser?.users_group_members?.length) {
      query = `?userGroupMembers=${currentUser.users_group_members}`
    }
    const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/sporetesting-boxes/corp-children${query}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const getInventoryItems = async (customerNumber: string) => {
  try {
    const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/auto-renewal`)
    
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const getCustomerMetadata = async (customerNumber: string) => {
  try {
    const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer/metadata`);
    const metadata: CustomerMetadata = response.data;

    return metadata
  } catch (error) {
    console.error(error);
    return null
  }
}

const getJobTitles = async () => {
  try {
    const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/job-titles`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

const getBalance = async (customerNumber: string) => {
  try {
    const { data } = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/nodus/balance`)
    return data.balance
  } catch(error) {
    console.error(error)
  }
}

const getChildPractices = async (customerNumber: string) => {
  const response = await axios.get(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/customer/corp-children`)
  const children: ChildPracticeMetadata[] =  response.data

  return children
}

export {
  getCustomer,
  getCustomerAddress,
  getCustomerService,
  getTeamMembers,
  getGroups,
  getCustomerMetadata,
  getJobTitles,
  getBioBoxes,
  getInventoryItems,
  getBalance,
  getChildPractices,
}
